'use strict';

// const processInclude = require('BASE/../util');

// var formValidation = processInclude(require('BASE/../components/formValidation'));
// var createErrorNotification = processInclude(require('BASE/../components/errorNotification'));
var formValidation = require('BASE/components/formValidation');
var createErrorNotification = require('BASE/components/errorNotification');

module.exports = {
  login: function() {
    $('form.login').submit(function(e) {
      var form = $(this);
      e.preventDefault();
      var url = form.attr('action');
      form.spinner().start();
      $('form.login').trigger('login:submit', e);
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function(data) {
          if (!data.success) {
            formValidation(form, data);
            $('form.login').trigger('login:error', data);
          } else {
            $('form.login').trigger('login:success', data);
            location.href = data.redirectUrl;
          }
        },
        error: function(data) {
          var redirectUrl = data.responseJSON && data.responseJSON.redirectUrl;

          if (redirectUrl) {
            window.location.href = redirectUrl;
            return;
          }

          $('form.login').trigger('login:error', data);
        },
        complete: function() {
          form.spinner().stop();
          form.find(':submit').prop('disabled', false);
        }
      });
      return false;
    });
  },

  register: function() {
    $('form.registration').submit(function(e) {
      var form = $(this);
      e.preventDefault();
      var url = form.attr('action');
      form.spinner().start();
      $('form.registration').trigger('login:register', e);
      $('form.registration .invalid-feedback').removeClass('d-block');
      $('form.registration .form-control').removeClass('is-invalid');
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function(data) {
          if (!data.success) {
            formValidation(form, data);
            $('form.registration').trigger('register:error', data);
          } else {
            $('form.registration').trigger('register:success', data);
            location.href = data.redirectUrl;
          }
        },
        error: function(err) {
          var response = err.responseJSON || {};

          if (response.redirectUrl) {
            window.location.href = response.redirectUrl;
          } else {
            if (response.errorMessage) {
              createErrorNotification($('.error-messaging'), response.errorMessage);
            } else if (response.fields) {
              Object.keys(response.fields).forEach(k => {
                var el = $('form.registration input[name="'+k+'"]');
                if (el && el.length) {
                  var parentEl = el.parent();
                  var invalidFeedback = parentEl.find('.invalid-feedback');
                  if (invalidFeedback) {
                    invalidFeedback.addClass('d-block');
                    invalidFeedback.html(response.fields[k]);
                  }
                  el.addClass('is-invalid');
                  $('form.registration #submitRegistration').attr('disabled', false);
                }
              })
            }
          }
        },
        complete: function() {
          form.spinner().stop();
          form.find(':submit').prop('disabled', false);
        }
      });
      return false;
    });
  },

  resetPassword: function() {
    $('.reset-password-form').submit(function(e) {
      var form = $(this);
      e.preventDefault();
      var url = form.attr('action');
      form.spinner().start();
      $('.reset-password-form').trigger('login:register', e);
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function(data) {
          if (!data.success) {
            formValidation(form, data);
          } else {
            $('.request-password-title').text(data.receivedMsgHeading);
            $('.request-password-body')
              .empty()
              .append('<p>' + data.receivedMsgBody + '</p>');
            if (!data.mobile) {
              $('#submitEmailButton')
                .text(data.buttonText)
                .attr('data-dismiss', 'modal');
            } else {
              $('.send-email-btn')
                .empty()
                .html('<a href="' + data.returnUrl + '" class="btn btn-primary btn-block">' + data.buttonText + '</a>');
            }
          }
        },
        complete: function() {
          form.spinner().stop();
          form.find(':submit').prop('disabled', false);
        }
      });
      return false;
    });
  },

  clearResetForm: function() {
    $('#login .modal').on('hidden.bs.modal', function() {
      $('#reset-password-email').val('');
      $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
    });
  }
};
